import {Stack, Typography} from "@mui/joy";
import React from "react";
import {formatDate} from "../../utils/formatDate";
import {useLanguage} from "../../hooks/useLanguage";

type RecentlyViewedResourceComponentProps = {
    resourceLabel?: string;
    date?: number
}

const RecentlyViewedResourceComponent = (props: RecentlyViewedResourceComponentProps) => {
    const language = useLanguage()
    return <Stack gap={1} minWidth={0}>
        <Typography level={"title-sm"} title={props.resourceLabel} sx={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            maxWidth: 200,
            textOverflow: "ellipsis"
        }}>{props.resourceLabel}</Typography>
        <Typography>{formatDate(props.date, navigator.languages?.find(value => value.substring(0.2) === language.lang))}</Typography>
    </Stack>
}

export default RecentlyViewedResourceComponent